import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticleGuide from "@/pages/article/page";
import ComparisonPage from "@/pages/comparison/page";
import BudgetSneakersPage from "@/pages/budget-sneakers/page";
import BestFindsPage from "@/pages/best-finds/page";
import CSSBuyReviewPage from "@/pages/cssbuy-review/page";
import KakoBuyReviewPage from "@/pages/kakobuy-review/page";
import SuperbuyReviewPage from "@/pages/superbuy-review/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-spreadsheet-guide-2026",
    element: <ArticleGuide />,
  },
  {
    path: "/cssbuy-vs-kakobuy",
    element: <ComparisonPage />,
  },
  {
    path: "/cheap-spreadsheet-sneakers-2026",
    element: <BudgetSneakersPage />,
  },
  {
    path: "/best-spreadsheet-finds-2026",
    element: <BestFindsPage />,
  },
  {
    path: "/cssbuy-deep-review",
    element: <CSSBuyReviewPage />,
  },
  {
    path: "/kakobuy-deep-review",
    element: <KakoBuyReviewPage />,
  },
  {
    path: "/superbuy-deep-review",
    element: <SuperbuyReviewPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;